import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';
import { IAgreementListFilterRaw } from 'APIPackage/AgreementListModule/interfaces/IAgreementListFilterRaw';
import { ITerritorialUnitSelectOption } from 'CorePackage/CatalogsModule/interfaces/ITerritorialUnitSelectOption';
import { IAgreementFilterForm } from 'AgreementListPackage/AgreementListPanelModule/interfaces/IAgreementFilterFormSecondary';
import { DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';

import { IAgreementListFilter } from '../interfaces/IAgreementListFilter';
import { passportTypeOptions } from '../constants/passportTypeOptions';
import { agreementStatusOptions } from '../constants/agreementStatusOptions';

interface IMapRawToAgreementFilter {
  raw: IAgreementListFilterRaw;
  territorialUnitsSelectOptions: ITerritorialUnitSelectOption[];
}

export function mapRawToAgreementFilter(data: IMapRawToAgreementFilter): IAgreementListFilter {
  const { raw, territorialUnitsSelectOptions } = data;

  const types: ISelectOption<string>[] = [];
  const statuses: ISelectOption<string>[] = [];

  if (raw?.isKnm) {
    types.push(passportTypeOptions[0]);
  }

  if (raw?.isPm) {
    types.push(passportTypeOptions[1]);
  }

  if (raw?.isDecision) {
    types.push(passportTypeOptions[2]);
  }

  raw.statuses?.forEach(status => {
    const option = agreementStatusOptions.find(i => i.id === status);

    if (option) {
      statuses.push(option);
    }
  });

  return {
    name: raw?.name,
    types,
    statuses,
    years:
      raw?.years?.map(year => ({
        id: String(year),
        label: String(year),
        value: String(year),
      })) || [],
    domains: raw?.domainIds?.reduce((domains: IAgreementFilterForm['domains'], domainId) => {
      const territorialUnitSelectOption = territorialUnitsSelectOptions.find(item => item.id === domainId);

      if (territorialUnitSelectOption) {
        const res = domains ?? [];

        res.push(territorialUnitSelectOption);

        return res;
      }

      return domains;
    }, undefined),
    includeDomainChild: raw?.includeDomainChild || false,
    executionAgreementDateBetween: raw?.executionAgreementDateBetween,
    ...(raw?.executionAgreementDateBetween?.[0] && {
      executionAgreementDateBetweenStart: formatDate({
        date: raw?.executionAgreementDateBetween?.[0],
        dateFormat: DATE_FORMAT_LONG_FNS,
      }),
    }),
    ...(raw?.executionAgreementDateBetween?.[1] && {
      executionAgreementDateBetweenEnd: formatDate({
        date: raw?.executionAgreementDateBetween?.[1],
        dateFormat: DATE_FORMAT_LONG_FNS,
      }),
    }),
    subjectInn: raw?.subjectInn,
    objectOgrn: raw?.objectOgrn,
    subjectOrgName: raw?.subjectOrgName,
  };
}
